import React from 'react';
import Navigation from './Navigation';

// import { Redirect } from 'react-router-dom';

const Header = () => {
    return (
        <header>
            <Navigation />
        </header>
    );
}

export default Header;